module.exports = __webpack_public_path__ + "img/premium.9b1e63a0.png";